import { Component, OnDestroy, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { AuthService } from 'src/app/shared/auth.service';
import { Router, ActivatedRoute, NavigationEnd, NavigationStart } from "@angular/router";
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { Notifications, RemindNotification } from 'src/app/Models/Notes';
import { DatePipe, Location } from '@angular/common';
import { TaskService } from '../../shared/task.service';
import { ClientService } from '../../client/client.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { AccountsService } from '../../shared/accounts.service';
import { AuthenticationService } from '../../commonservice/authentication.service';
import { TimesheetComponent } from '../../manageprofile/timesheet/timesheet.component';
import { CommonService } from '../../shared/common.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Clientdetails } from 'src/app/Models/clients';
import { EventService } from 'src/app/shared/event.service';
import { PermissionService } from '../../shared/permission.service';
import { ClientTabs, CommonEvents } from 'src/app/shared/app.constant';
import { ToastrService } from 'ngx-toastr';
import { of, Subject, Subscription } from 'rxjs';
import { take, switchMap, tap, takeUntil, filter, debounceTime, finalize } from 'rxjs/operators';
import { SMClientService } from 'src/app/client/SM-client.service';
import { CommunicationService } from 'src/app/commonservice/communication.service';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { UserManagementService } from 'src/app/shared/userManagement.service';
import { AddDisbursementComponent } from 'src/app/shared/components/add-disbursement/add-disbursement.component';

export interface GlobalSearchResult {
  contextType: 'Client' | 'Group' | 'Contact';
  id: number;
  name: string;
  code?: string | null;
  email?: string | null;
  phone?: string | null;
  groupid: number;
  groupName?: string | null;
  groupCode?: string | null;
  initials?: string;
  emailType?: string | null;
}

export interface GlobalSearchResponse {
  results: GlobalSearchResult[];
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css','./clientbadge.scss']
})

export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild(MatMenuTrigger, { static: false }) trigger: MatMenuTrigger;
  Contactpage: any;
  isWipDisable: boolean;
  isInvoiceDisable: boolean;
  isPlannedInvoiceDisable: boolean;
  @ViewChild('quickAddTimelogModalPopup', { static: true }) public quickAddTimelogModalPopup: any; //ModalDirective;
  @ViewChild('createjobModalPopup', { static: false }) public createjobModalPopup: any; //ModalDirective
  @ViewChild('createclientModalPopup', { static: false }) public createclientModalPopup: any; //ModalDirective
  @ViewChild('SetReminderModalPopup', { static: false }) public SetReminderModalPopup: any; //ModalDirective;
  @ViewChild(TimesheetComponent, { static: false }) public timesheet1: TimesheetComponent;
  @ViewChild('WarningPopup', { static: false }) public WarningPopup: ModalDirective;
  @ViewChild('createcontactModalPopup', { static: true }) public createcontactModalPopup: any; //ModalDirective;
  BackgroundColor: string = "";
  TextColor: string = "";
  public alertmsg: string = "";
  public warningmsggroupDelete: string = "";
  userName: any;
  tempload: number = 0;
  IsclientAdd: boolean = false;
  isJobAdd: boolean = false;
  checktimesheet: boolean = true;
  public isAddJob: number = 0;
  showContactInfo: boolean = false;
  showBillingInfo: boolean = false;
  showClientList: boolean = false;
  showClientClassic: boolean = false;
  isClass: boolean = true
  isCollapse:boolean = true
  _lstNotifications: Array<Notifications> = [];
  Ncount: any;
  remindertime: any;
  public remind = new RemindNotification();
   headers: any; fyForSelection = [];
  clientCombo: any;
  ClientId: any;
  clientEntityType: string;
  clientName: string;
  preferredname: string;
  enttypeId: any;
  clientCode: string;
  clientBackgroundColor: string;
  clientTextColor: string;
  shortName: string;
  userFullName : string;
  clientShortName: string;
  defaultpartnerid: string;
  defaultmanagerid: string;
  lastselectedmanager: any;
  lastselectedpartner: any;
  public dmsDynamiclink: any = '#';
  public imageSource: any = '';
  public clientstatus: string = 'Active';
  public clientDataModal = new Clientdetails();
  // Developer Rahul Newara Ticket CUST-1240 Date: 08-06-2022
  public IsinvoicesView: boolean = true;
  public IsPlannedinvoicesView: boolean = true;
  public IsWIPView: boolean = true;
  StatusName = [];
  timesheetClientList: any[] = [];
  hideActivity: boolean = false;
  public clientdefaultEmail: string = '';
  public clientdefaultPhone: string = '';
  public notfycheck: boolean = false;
  public infocheck: boolean = false;
  public passwordcheck: boolean = false;
  radioValue;
  canShowModalPopup: string = '';
  public tempContactid: any = 0;
  tempcontactload: number;
  clientCurrentTab: ClientTabs = ClientTabs.Client;
  public _dmsPType: string  = '';// Dev: Sandesh ; Date: 21-03-2025,  Sharepoint
  // Permissions for SharePoint - Dev: Sandesh ; Date: 21-03-2025
  public permissions = {
    isFileTemplate: false,
    isViewDocuments: false,
    isAddDocuments: false,
    isManageDocuments: false,
    isManageFolders: false
  };
  private sub = new Subscription();
  unsubscribe = new Subject<void>();
  modalRef: BsModalRef;

  private searchSub?: Subscription;
  searchText = '';
  hasSearched = false;
  private loaderDelayTimer: any;
  private loaderStartTime = 0;
  search$ = new Subject<string>();
  loading = false;
  tabs = ['All', 'Clients', 'Groups', 'Contacts'];
  activeTab = 'Clients'; // default tab UI

  results: GlobalSearchResult[] = [];
  filteredClients: GlobalSearchResult[] = [];
  filteredGroups: GlobalSearchResult[] = [];
  filteredContacts: GlobalSearchResult[] = [];
  isFirstSearch = true;
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;
  contactcountries: any[] = [];
  private readonly googleUtil = PhoneNumberUtil.getInstance();
  showDropdown: boolean = false;
  private routerSub!: Subscription;

  constructor(private auth: AuthService, private accountsService: AccountsService, private router: Router, public datepipe: DatePipe, private _clientService: ClientService, private _taskService: TaskService, private sanitizer: DomSanitizer, private common: CommonService, private route: ActivatedRoute
    ,private modalService: BsModalService, private eventService: EventService, private authenticationService: AuthenticationService,private location: Location,
    private permissionService: PermissionService, private _toastr: ToastrService,private stateManagement: SMClientService,private communicationService: CommunicationService, private userManagementService: UserManagementService) {
    this.eventService.getEvent('NOTIFICATION_COUNT').pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      if (res == 1) {
        this.Ncount = this.Ncount > 1 ? this.Ncount - 1 : null;
      } else {
        this.Ncount += 1;
      }
    })

    this.eventService.getEvent('RESET_DISABLE').pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      if (res) {
        this.isWipDisable = false;
      }
    })

    this.eventService.getEvent(CommonEvents.CLIENTNAME_UPDATE).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      if (res) {
          this.getClientsForCombo();
      }
    });
    this.handleRouterEvents();
    this.search$
      .pipe(debounceTime(300))
      .subscribe((text: string) => {
        this.callSearchApi(text);
      });
  }

  ngOnInit(): void {
    this.getContactCountries();
    this.stateManagement.updateData(this.stateManagement.getClientDetailsById, undefined);
    this.sub.add(this.permissionService.permissionSet$.pipe(takeUntil(this.unsubscribe)).subscribe((userPermissions) => {
      if(userPermissions != null) {
        this.GetUserPermissions();
        this.refreshClientData();
        this.userName = localStorage.getItem('Email');
        this.userFullName = localStorage.getItem("FullName");
        this.BackgroundColor = localStorage.getItem("BackgroundColor");
        this.TextColor = localStorage.getItem("TextColor");
        this.GetDashboardNotificationsCount();
        this._dmsPType = localStorage.getItem('DMSProviderType'); // Dev: Sandesh ; Date: 21-03-2025,  Sharepoint
      }
    }));

    this.sub.add(this.common.dataSubject.pipe(takeUntil(this.unsubscribe)).subscribe((res: any) => {
      if (res === 1) {
        this.GetNotifications();
        this.common.updateNotificationCount(0);
      }
    }))

    this.sub.add(this.common.onContactPage.pipe(takeUntil(this.unsubscribe)).subscribe(value => {            
      const clientId = this.route.snapshot.queryParams['clientId'];
      const isClientContact = this.router.url.includes('/client/contact')
      if (isClientContact && clientId) {
        this.ClientId = +clientId;                
        this.showContactInfo = true;
        this.getClientsForCombo();
      } else {
        this.showContactInfo = false
      }
    }));

    const showinvoices = this.route.snapshot.queryParams["showinvoice"];
    if (showinvoices != undefined) {
      if (showinvoices) {
        setTimeout(() => {
          let x = document.getElementById("wip-tab");
          let y = document.getElementById("invoice-tab");
          x?.classList?.remove('active');
          y?.classList.add('active');
          this.isWipDisable = false;
        }, 500);

      }
    }
    if (!this.IsclientAdd) {      setTimeout(() => {        this.checkflag();      }, 500);     }
    if (!this.isJobAdd) {      setTimeout(() => {        this.checkflag();      }, 500);     }
    this.sub.add(this.common.notifications$.pipe(takeUntil(this.unsubscribe)).subscribe(value => {
      if(value != null)
      this.setNotificationsData(value);
    }));

    this.route.queryParams
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(params => {

        const clientId = params['clientId'];
        // CUST- 9287 - DMS Shared component changes - Jayaram Date: 04-03-2026
        const documentTabQueryParams = { currentClientId: params['currentClientId'], screenType: params['screenType'] };  

        const isContactNavigation = this.router.url.includes('/client/contact');
        const isDocumentTabNavigation = (documentTabQueryParams?.currentClientId || documentTabQueryParams?.screenType);

        if ((isContactNavigation && clientId)) {
          this.ClientId = clientId;
          this.showContactInfo = true;
          if(!isDocumentTabNavigation) { this.getClientsForCombo() }
        } else {
          this.showContactInfo = false;
        }

      });
    window.addEventListener('clear-quick-search', this.clearSearchText);
    this.handleClientModuleTabsHighlighting(this.router.url);
    this.routerSub = this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(() => {
      this.closeDropdown();
    });
  }

  handleRouterEvents() {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd), takeUntil(this.unsubscribe))
      .subscribe(evt => {
        const currentUrl = evt.url || evt.urlAfterRedirects || '';
        this.handleClientModuleTabsHighlighting(currentUrl);
        this.showBillingInfo = currentUrl.startsWith('/billing');
      });
  }

  handleClientModuleTabsHighlighting(currentUrl: string): void {
    this.showClientList = false;
    this.showClientClassic = false;

    if (currentUrl.includes('/client/client-classic')) {
      this.showClientClassic = true;

      if (currentUrl.includes('/client/client-classic/groups')) {
        this.clientCurrentTab = ClientTabs.Groups;
      } else if (currentUrl.includes('/client/client-classic/contacts')) {
        this.clientCurrentTab = ClientTabs.Contacts;
      } else {
        this.clientCurrentTab = ClientTabs.ClientClassic;
      }

      return;
    }

    if (currentUrl.includes('/client/clientlist')) {
      this.clientCurrentTab = ClientTabs.Client;
      this.showClientList = true;
    } else if (currentUrl.includes('/client/groups')) {
      this.clientCurrentTab = ClientTabs.Groups;
      this.showClientList = true;
    } else if (currentUrl.includes('/client/contacts')) {
      this.clientCurrentTab = ClientTabs.Contacts;
      this.showClientList = true;
    }
  }

  getClientsForCombo() {
    this.GetClientProfileById(this.ClientId)
    this._clientService.GetClientListForCombo().pipe(takeUntil(this.unsubscribe)).subscribe(result => {
        if (result) {
          this.clientCombo = result;
          this.timesheetClientList = result
        }
        const res = this.clientCombo.filter(x => x.clientId == Number(this.ClientId));
        if (res.length == 1) {
          this.clientName = res[0].clientName;
          this.preferredname = res[0].preferredname;
          this.clientCode = res[0].clientCode;
          this.enttypeId = res[0].entityTypeId;
          this.clientBackgroundColor = res[0].backgroundColor;
          this.clientTextColor = res[0].textColor;
          let _namear = this.clientName.split(" ", 3);
          if (_namear != undefined && _namear.length > 0) {
            let nam = _namear[0].replace(/\s/g, "").substring(0, 1);
            if (_namear.length > 1) {
              nam = nam + _namear[1].replace(/\s/g, "").substring(0, 1);
            }
            this.clientShortName = nam;
          } else {
            this.shortName = 'MN';
          }
          if (res[0].entityTypeId == 1) { this.clientEntityType = 'Individual'; }
          else if (res[0].entityTypeId == 2) { this.clientEntityType = 'Company'; }
          else if (res[0].entityTypeId == 3) { this.clientEntityType = 'Trust'; }
          else if (res[0].entityTypeId == 4) { this.clientEntityType = 'Partnership'; }
          else if (res[0].entityTypeId == 5) { this.clientEntityType = 'SMSF'; }
          else { this.clientEntityType = ''; }
          this.common.clientEntityType.next(this.clientEntityType);
        }
      });
  }

  GetClientProfileById(ClientId) {
    this.imageSource = "";
    const id = Number(ClientId);
    if(this.stateManagement.getClientDetailsById?.value?.clientId != id) {
      this._clientService.getClientDetailsById(ClientId).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
        this.formatClientProfile(result);
        this.stateManagement.updateData(this.stateManagement.getClientDetailsById, result);
      });
    } else {
      this.formatClientProfile(this.stateManagement.getData(this.stateManagement.getClientDetailsById));
    }
  }

 formatClientProfile(res) {
   if (res) {
     this.defaultmanagerid = res.managerId != "" ? res.managerId : undefined;
     this.defaultpartnerid = res.partnerId != "" ? res.partnerId : undefined;
     this.preferredname = res.preferredname;
     this.lastselectedmanager = this.defaultmanagerid;
     this.lastselectedpartner = this.defaultpartnerid;
     this.dmsDynamiclink = 'https://dms.kloudconnect.com.au/kcdms/#/silent-login/' + res.acaSilentLoginCreds + '/' + res.acaClientParentId;
     this.imageSource = res.clientProfileImg != '' ? this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${res.clientProfileImg}`) : this.imageSource;
     this.clientstatus = res.clientStatus;
     this.clientDataModal = res;
     this.clientDataModal.emailaddress = res.emailaddress
     this.clientDataModal.phonenumber = res.phonenumber; this.preferredname = res.preferredname;
     if (res.tagName != null)
       this.StatusName = res.tagName;
     }
  }

  wipshow() {
    this.common.billingTab.next('wip');
    this.isWipDisable = true;
    this.isInvoiceDisable = false;
    this.isPlannedInvoiceDisable = false;
  }

  invoiceshow()  {
    this.common.billingTab.next('invoice');
    this.isWipDisable = false;
    this.isInvoiceDisable = true;
    this.isPlannedInvoiceDisable = false;
  }

  plannedinvoiceshow()  {
    this.common.billingTab.next('plannedinvoice');
    this.isWipDisable = false;
    this.isInvoiceDisable = false;
    this.isPlannedInvoiceDisable = true;
    this.IsPlannedinvoicesView = true;
  }

  showclientlist(tab: string) {
    this.router.navigate(['/client', tab], { queryParamsHandling: 'merge' });
  }

  handleClientClassicNavigation(tab: string) {
    this.router.navigate(['/client/client-classic', tab], { queryParamsHandling: 'merge' });
  }

  changepsw() {
    this.accountsService.GetAppsettingsB2C().pipe(takeUntil(this.unsubscribe)).subscribe(result => {
      if (result) {
        window.location.href = result.b2CChangePassword;
      }
    })
  }

  openuserprofile(){
    this.router.navigate(['/dashboard/userprofile']);
  }

  closeCreateEditJobsPopUp() {
    this.Contactpage = 0;
    this.modalRef.hide();
  }

  openModal(template: any, size: string, modalOverlayName: string) {
    this.canShowModalPopup = modalOverlayName;
    this.modalRef = this.modalService.show(template, {class: `modal-dialog-centered ${size} cmn-modal-dsgn`, backdrop: 'static'});
  }

  OpenErrorMsgnotify() {
    this.warningmsggroupDelete = "All unsaved data will be lost."  +  "Are you sure you want to leave?";
    this.notfycheck = true;
    const resval = localStorage.getItem("addtimesheetnotify");
    if (resval == "true") {
      this.checktimesheet = false;
       this.router.navigate(['/dashboard/notification/']);
    } else {
      this.checktimesheet = false;
      this.router.navigate(['/dashboard/notification/']);
    }
  }

  closeCreateclientPopup() {
    this.modalRef.hide();
  }

  GetNotifications() {
    this._clientService.getNotificationsDetails(0).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
      if (result) {
        let notificationsObject = {
          notificationsData: [...result],
          userOpenNotificationsCount: result.filter(item => item.status == 'Open').length
        }
        this.setNotificationsData(notificationsObject)
      }
    });
  }

  GetDashboardNotificationsCount() {
    this._clientService.getDashboardNotificationsDetails().pipe(takeUntil(this.unsubscribe)).subscribe(result => {
        if (result) {
          this.setNotificationsData(result)
        }
    },
    error => {
      this._toastr.error('Something went wrong at Notifications in Header');
    });
  }

  setNotificationsData(result) {
    this._lstNotifications = result.notificationsData;
      this.Ncount = result.userOpenNotificationsCount == 0 ? "" : result.userOpenNotificationsCount > 9 ? "9+" : result.userOpenNotificationsCount;
      this._lstNotifications.forEach((element,index) => {  // Ramya; CUST-2473; 02-Feb-2024
      if (element.notificationDetails == "null") {
          this._lstNotifications[index].notificationDetails = "";
      }
    })
  }

  refreshClientData() {  // Ramya; CUST-2405; 16-Feb-2024
    if (!(this.ClientId == undefined || this.ClientId == "" )) {
      this.GetClientProfileById(this.ClientId);
    }
  }

  MarkasRead(notificationid: any, evt: any, ischekced: any, i: any) {
    if (ischekced == 1)
      this._lstNotifications[i]["markasRead"] = false;
    else
      this._lstNotifications[i]["markasRead"] = true;

    this._clientService.getNotificationasRead(notificationid, this._lstNotifications[i]).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
      if (result.success) {
        this.GetNotifications();
      }
    });
  }

  MarkAllAsRead() {
    this._clientService.getMarkAllAsRead().pipe(takeUntil(this.unsubscribe)).subscribe(result => {
      if (result.success) {
        this.GetNotifications();
      }
    });
  }

  SetReminderNotification() {
    this.SetValue(this.remind.value);
    this.remindertime = new Date(this.datepipe.transform(this.remindertime, 'yyyy-MM-dd HH:mm:ss')).toISOString()
    this.remind.RemindDatetime = this.remindertime;
    this.remind.RemindValue = this.remind.value;
    this._clientService.setRemainderNotification(this.remind).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
      if (result.success) {
        this.GetNotifications();
        this.modalRef.hide();
      }
    });
  }

  SetNotificationId(notificationId: any) {
    this.remind.NotificationId = notificationId;
  }

  SetReminderValue(val: any, evt: any) {
    if (evt.target.checked == true)
      this.remind.value = val;
  }

  SetValue(id: any) {
    let currentdate = new Date();
    switch (id) {
      case 1:
        this.remindertime = new Date(currentdate.setMinutes(currentdate.getMinutes() + 15));
        break;
      case 2:
        this.remindertime = new Date(currentdate.setMinutes(currentdate.getMinutes() + 30));
        break;
      case 3:
        this.remindertime = new Date(currentdate.setHours(currentdate.getDate() + 1));
        break;
      case 3:
        this.remindertime = new Date(currentdate.setDate(currentdate.getDate() + 1));
        break;
      default:
        this.remindertime = null;
    }
  }

  ClearNotifications(NId: any) {
    const index = this._lstNotifications.findIndex(x => x.notificationId === NId);
    let res = '';
    for (let i = index; i < this._lstNotifications.length; i++) {
      if (this._lstNotifications[i]["isgroupby"] == 1 && i != index)
        break;
      res = res + ',' + this._lstNotifications[i]["notificationId"];
    }
    res = res.slice(1);
    this._clientService.clearNotifications(res).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
      if (result.success) {
        this.GetNotifications();
      }
      else {
      }
    });
  }

  NavigatetoPage(type, jobId, assigned, selectedDate, isTimesheetPublished: boolean) {
    let url;
    let Contextid;

    if (type == 'Job') {
      url = location.origin + '/job/jobprofile?jobId=' + jobId;
      this.RedirecttoLink(url);
    }
    else if (type == 'Activity') {
      this.communicationService.GetActivitybyId(jobId, type).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
        if (result) {
          Contextid = result.clientId;
          url = location.origin + '/job/jobprofile?jobId=' + Contextid + '&Task=' + jobId;
          this.RedirecttoLink(url);
        }
      });
    }
    else if (type == 'Communication') {
      this.communicationService.GetActivitybyId(jobId, type).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
        if (result) {
          Contextid = result.clientId;
          url = location.origin + '/client/contact?clientId=' + Contextid + '&Task=' + jobId;
          this.RedirecttoLink(url);
        }
      });
    }
    else if (type == 'Task') {
      this._taskService.GetTaskDetailById(jobId).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
        if (result != '' || result != undefined) {
          Contextid = result[0].contestId;
          url = location.origin + '/job/jobprofile?jobId=' + Contextid + '&Task=1';
          this.RedirecttoLink(url);
        }
      });
    }
    else if (type == 'Notes') {
      if (assigned == 'Job') {
        this._clientService.GetNotesDetailsByTaskReplyId(jobId).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
          if (result != '' || result != undefined) {
            url = location.origin + '/job/jobprofile?jobId=' + result.contextId + '&Task=1' + '&cid=' + result.noteId;
            this.RedirecttoLink(url);
          }
        });
      }
      else {
        this._clientService.GetNotesDetailsByReplyId(jobId).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
          if (result != '' || result != undefined) {
            if (result.contextType == 'Client') {
              url = location.origin + '/client/contact?clientId=' + result.contextId + '&Task=3' + '&cid=' + result.noteId;
              this.RedirecttoLink(url);
            }
            else if (result.contextType == 'Job') {
              url = location.origin + '/job/jobprofile?jobId=' + result.contextId + '&Task=1' + '&cid=' + result.noteId;
              this.RedirecttoLink(url);
            }
          }
        });
      }
    }
    else if (type == 'Invoice') {
      this._clientService.GetClientId(jobId).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
        if (result) {
          Contextid = result.clientId;
          url = location.origin + '/client/contact?clientId=' + Contextid + '&Type=Invoice';
          this.RedirecttoLink(url);
        }
      });
    }
    else if (type == 'Timesheet') {
      const role = localStorage.getItem("RoleName");
      const TimesheetPermission = JSON.parse(localStorage.getItem('TimesheetPermission'));
      const isPartnerOrManager = role === 'Partner' || role === 'Manager';
      if (!isTimesheetPublished) {
        if (TimesheetPermission?.timeSheettype) {
          let _timesheeturl = isPartnerOrManager ? '/manageprofile/managertimeSheet' : '/manageprofile/usertimeSheet';
          url = location.origin + _timesheeturl + '?selectDate=' + this.datepipe.transform(selectedDate, 'YYYY-MM-dd').toString();
          this.RedirecttoLink(url);
        }
      }
      else {
        if (TimesheetPermission?.timeSheettype && TimesheetPermission?.timeSheetApproval && isPartnerOrManager) {
          url = location.origin + '/manageprofile/managertimeSheet?Id=' + jobId;
          this.RedirecttoLink(url);
        }
      }
    }
    else if (type == 'Planning') {
      url = location.origin + '/planning/planninglist';
      this.RedirecttoLink(url);
    }
    else if (type == 'WIPStandardHours') { // Dev Rahul Newara CUST-3980 Date:17-04-2024
      url = location.origin + '/manageprofile/managertimeSheet';
        this.RedirecttoLink(url);
    }
    else if (type == 'WIPControl') {
        url = location.origin + '/manageprofile/managertimeSheet';
        this.RedirecttoLink(url);
    }
    else if (type == 'WIPInvoice') {
      this.router.navigate(['/billing/invoices']);
    }
  }

  RedirecttoLink(url) {
    let link = document.createElement('a');
    if (link.download !== undefined) {
      link.setAttribute('href', url);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  checkflag() { // Dev: Sachin Yadav;   Date: 28-oct-2022; Ticket: CUST-1727.               // this method will be calling only for client permission exception
    if (this._dmsPType?.toLowerCase() === "sharepoint") { // Dev: Sandesh ; Date: 21-03-2025,  Sharepoint
      this.SPPermissionCall();
    }
    const userPermissionsParsed = JSON.parse(localStorage.getItem('UserPermissions'));
    if (userPermissionsParsed != null) {
      const privilegeArr = userPermissionsParsed.filter(x => x.area === 'Clients')
      const privilege = JSON.parse(privilegeArr[0].privilege)
      for (let i = 0; i < privilege.length; i++) {
        if (privilege[i].Key == 'Add') {
          this.IsclientAdd = (privilege[i].Value == "True" ? true : false);
          break;
        }
      }
      let privilegeJobArr = userPermissionsParsed.filter(x => x.area === 'Jobs')
      let jobPrivilege = JSON.parse(privilegeJobArr[0].privilege)
      for (let i = 0; i < jobPrivilege.length; i++) {
        if (jobPrivilege[i].Key == 'Add') {
          this.isJobAdd = (jobPrivilege[i].Value == "True" ? true : false);
          break;
        }
      }
    }
  }

  GetUserPermissions() {
    const userPermissionsParsed = JSON.parse(localStorage.getItem('UserPermissions'));
    if (userPermissionsParsed != null) {
      let privilegeArr = userPermissionsParsed.filter(x => x.area === 'Clients')
      let privilege = JSON.parse(privilegeArr[0].privilege)
      for (let i = 0; i < privilege.length; i++) {
        if (privilege[i].Key == 'Add') {
        this.IsclientAdd = (privilege[i].Value == "True" ? true : false);
        break;
        }
      }
      privilegeArr = userPermissionsParsed.filter(x => x.area === 'Jobs')
      privilege = JSON.parse(privilegeArr[0].privilege)
      for (let i = 0; i < privilege.length; i++) {
        if (privilege[i].Key == 'Add') {
          this.isJobAdd = (privilege[i].Value == "True" ? true : false);
          break;
        }
      }
      // Developer Rahul Newara Ticket CUST-1240 Date: 08-06-2022
      privilegeArr = userPermissionsParsed.filter(x => x.area === 'Billing')
      privilege = JSON.parse(privilegeArr[0].privilege)
      for (let i = 0; i < privilege.length; i++) {
        if (privilege[i].Key == 'View') {
          this.IsinvoicesView = (privilege[i].Value == "True" ? true : false);
        }
        else if (privilege[i].Key == 'WIPView') {
          this.IsWIPView = (privilege[i].Value == "True" ? true : false);
        }
      }
    }
  }

  logoutB2C(): void {
    /* KC logout */
    this.auth.logout()
      .pipe(
        takeUntil(this.unsubscribe),
        finalize(() => {
          /* keyclock logout */
          this.authenticationService.logout();
        })
      )
      .subscribe({
        next: () => {},
        error: () => {}
      });
  }

  getShortName() {
    return localStorage.getItem('shortName') || 'KC';
  }

  getBackgroundColour() {
    return localStorage.getItem("BackgroundColor");
  }

  getTextColour() {
    return localStorage.getItem("TextColor");
  }

  goToLink(){
    const url = "https://kloudconnect.atlassian.net/jsd-login-v2/v2/customer/login/saml/start?customer_directory_id=19816bbe-8115-4e40-b618-fbfa5a7b1990&connection=saml-acd85a1a-e74a-4df2-a3f3-0c2545179b6a&continue=https%3A%2F%2Fkloudconnect.atlassian.net%2Fservicedesk%2Fcustomer%2Fsso-redirect%3Fcontinue%3D%2Fservicedesk%2Fcustomer%2Fportals&sso_test=false&login_hint=" + localStorage.getItem("Email");
    window.open(url, "_blank");
  }

  closeCreatecontactPopup() {
    this.tempContactid = 0;
    this.modalRef.hide();
  }

  OpenCreatecontactPopup() {
    this.tempContactid = 0;
    this.tempcontactload = 1;
    this.modalRef = this.modalService.show(this.createcontactModalPopup, { class: 'modal-lg modal-dialog-centered cmn-modal-dsgn createContactPopup m-auto', backdrop: 'static' });
  }

  closeCreateDocTemplateModal() {
    this.modalRef.hide();
    // Notify the File component
    this.common.triggerSPCreateDocEvent();
  }

  SPPermissionCall() {
    this.permissionService.spPermissionSet$.pipe(
      take(1),
      switchMap((permissions) =>
        permissions ? of(permissions) : this.permissionService.getSPUserPermission(0)
      ),
      tap((fetchedPermissions) => {
        this.permissions.isFileTemplate = fetchedPermissions.IsFileTemplate;
        this.permissions.isAddDocuments = fetchedPermissions.IsAddDocuments;
        this.permissions.isViewDocuments = fetchedPermissions.IsViewDocuments;
        this.permissions.isManageDocuments = fetchedPermissions.IsManageDocuments;
        this.permissions.isManageFolders = fetchedPermissions.IsManageFolders;
      })
    ).pipe(takeUntil(this.unsubscribe)).subscribe();
  }

  // Dev: Uzaif; CUST-7314; 24-07-2025
  openDisbursementPopup(){
    this.modalRef = this.modalService.show(AddDisbursementComponent, {
        class: 'modal-md modal-dialog-centered cmn-modal-dsgn add-disbursement-popup-container',
        backdrop: 'static',
        initialState: {
            data: {
              dsid: null,
              isEditMode: false,
              jobId: null,
              jobName: null,
              jobCodeQry: null,
              jobIdStr: null,
              isOpenFromQuickLinks: true
          }
        }
    });

    this.modalRef.content.closeDisbursePopUp.pipe(takeUntil(this.unsubscribe)).subscribe((res:any) => {
      //to update the disbursement data in the wip grid when the disbursement is added from global header
      this.closeQuickAddTimesheetpopupFromHeader(res);
      this.modalRef.hide();
    });
  }

  openGlobalUploadPopup(template:any){
    this.modalRef = this.modalService.show(template, {class: `modal-dialog-centered modal-md cmn-modal-dsgn global-action-upload`, backdrop: 'static'});
  }
  
  closeGlobalUploadPopup(event?: any) {
    this.modalRef?.hide();
  }
  
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.routerSub?.unsubscribe();
    this.sub.unsubscribe();
    window.removeEventListener('clear-quick-search', this.clearSearchText);
  }

  onSearch() {
    const normalized = this.searchText
      ?.replace(/\s+/g, ' ')
      .trim();
    if (normalized.length >= 3) {
      this.search$.next(normalized);
    }
  }

  showSection(section: string) {
    //return this.activeTab === 'All' || this.activeTab === section;

    if (this.activeTab === 'All') return true;

    return this.activeTab === section;
  }

  isOpen = false;

  toggleAuto() {
    this.isOpen = !this.isOpen;
  }

  clearSearch(event: MouseEvent) {
    event.stopPropagation();
    this.resetSearch();
    setTimeout(() => {
      this.searchInput.nativeElement.focus();
    });
  }

  private getPhoneDisplay(data: any): string {
    const rawPhone = String(data?.phone ?? '').trim();
    if (!rawPhone) {
      return '';
    }

    const countryCode = this.contactcountries.find(c =>
      String(c.countryId) === String(data?.countryId)
    )?.code;

    try {
      const parsed = this.googleUtil.parseAndKeepRawInput(rawPhone, countryCode || '');
      const formatted = this.googleUtil.format(parsed);
      return String(data?.isdCode) === '61'
        ? `0${formatted}`
        : `(+${data?.isdCode}) ${formatted}`;
    } catch {
      return String(data?.isdCode) === '61'
        ? rawPhone
        : `(+${data?.isdCode}) ${rawPhone}`;
    }
  }

  highlight(text: any, data: any, isPhone: boolean): SafeHtml {
    const sourceText = isPhone ? this.getPhoneDisplay(data) : String(text ?? '');

    if (!sourceText) {
      return sourceText;
    }

    if (!this.searchText) {
      return sourceText;
    }

    const tokens = this.searchText
      .replace(/\+/g, ' ')
      .trim()
      .split(/\s+/)
      .filter(Boolean);

    if (!tokens.length) {
      return sourceText;
    }

    const escapedTokens = tokens.map(t =>
      t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    );

    const regex = new RegExp(`(${escapedTokens.join('|')})`, 'gi');

    const highlighted = sourceText.replace(
      regex,
      `<mark class="search-highlight">$1</mark>`
    );

    return this.sanitizer.bypassSecurityTrustHtml(highlighted);
  }

  applyLocalFilter() {
    if (!this.results) {
      return;
    }
    this.filteredClients = this.results.filter(r => r.contextType === 'Client');
    this.filteredGroups = this.results.filter(r => r.contextType === 'Group');
    this.filteredContacts = this.results.filter(r => r.contextType === 'Contact');
  }

  callSearchApi(text: string) {
    if (!text || !text.trim()) return;
    if (this.searchSub) {
      this.searchSub.unsubscribe();
    }
    clearTimeout(this.loaderDelayTimer);
    this.loaderDelayTimer = setTimeout(() => {
      this.loading = true;
      this.loaderStartTime = Date.now();
    }, 300);


    let apiParam = 4; // ALL

    if (!this.isFirstSearch) {

      const map = {
        'Clients': 1,
        'Groups': 2,
        'Contacts': 3,
        'All': 4
      };

      apiParam = map[this.activeTab];
    }

    this._clientService.searchGlobalClients(text, apiParam)
      .subscribe({
        next: (res: GlobalSearchResponse) => {
          this.hideLoaderSafely();
          this.results = res.results.map(r => ({
            ...r,
            initials: this.getInitials(r.name)
          }));
          this.hasSearched = true;
          if (this.isFirstSearch) {
            this.activeTab = 'Clients'; // UI default
            this.isFirstSearch = false;
          }

          this.applyLocalFilter();
        },
        error: () => {
          this.hideLoaderSafely();
        }
      });
  }
  onTabChange(tab: string) {
    this.activeTab = tab;
    this.applyLocalFilter();
    const hasData =
      (tab === 'Clients' && this.filteredClients.length > 0) ||
      (tab === 'Groups' && this.filteredGroups.length > 0) ||
      (tab === 'Contacts' && this.filteredContacts.length > 0);

    if (!hasData) {
      this.callSearchApi(this.searchText);
    }

  }

  resetSearch() {
    this.searchText = '';
    this.results = [];
    this.filteredClients = [];
    this.filteredGroups = [];
    this.filteredContacts = [];
    this.isFirstSearch = true;
    this.activeTab = 'Client';
    this.hasSearched = false;
  }
  clearSearchText = () => {
    this.searchText = '';
  };

  getCodeGroup(c: any): string {
    if (c.code && c.groupName) {
      return `${c.code} | ${c.groupName}`;
    }
    return c.code || c.groupName || '';
  }

  getInitials(name?: string | null): string {
    if (!name) return '';
    let clean = name
      .replace(/[<>]/g, ' ')
      .replace(/[^a-zA-Z\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    if (!clean) return '';
    return clean
      .split(' ')
      .filter(w => w.length)
      .map(w => w[0])
      .slice(0, 2)
      .join('')
      .toUpperCase();
  }

  openSameTab(item: any) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      if (item.contextType === 'Client' || item.contextType === 'Group') {
        this.router.navigate(
          ['/client/contact'],
          {
            queryParams: {
              tab: 'profile',
              clientId: item.id
            }
          }
        );
      } else if (item.contextType === 'Contact') {
        this.router.navigate(
          ['/client/contacts'],
          {
            queryParams: {
              contactId: item.id
            }
          }
        );
      }

    });
  }

  openNewTab(item: any) {
    let url = '';
    let windowName = '';

    if (item.contextType === 'Client' || item.contextType === 'Group') {
      url = `/client/contact?clientId=${item.id}&tab=profile`;
      windowName = `client-${item.id}`;
    }
    else if (item.contextType === 'Contact') {
      url = `/client/clientlist?tab=contacts&contactId=${item.id}`;
      windowName = `contact-${item.id}`;
    }

    if (!url) return;

    const win = window.open(location.origin + url, windowName);
    if (win) {
      win.focus();
    }
  }

  onEnter() {
    const normalized = this.searchText
      ?.replace(/\s+/g, ' ')
      .trim();
    if (!normalized) return;
    if (normalized.length >= 3) {
      return;
    }
    this.callSearchApi(normalized);
  }

  private hideLoaderSafely() {
    clearTimeout(this.loaderDelayTimer);

    if (!this.loading) {
      return;
    }

    const elapsed = Date.now() - this.loaderStartTime;
    const minVisibleTime = 300;

    if (elapsed >= minVisibleTime) {
      this.loading = false;
    } else {
      setTimeout(() => {
        this.loading = false;
      }, minVisibleTime - elapsed);
    }
  }

  private focusSearch() {
    this.searchInput.nativeElement.focus();
    //this.searchInput.nativeElement.select(); 
  }

  @HostListener('window:keydown', ['$event'])
  onKeydown(e: KeyboardEvent) {

    if (
      document.querySelector('.cdk-overlay-pane') ||
      document.querySelector('modal-container')
    ) {
      return;
    }

    const el = e.target as HTMLElement | null;
    const isTypingTarget =
      !!el &&
      (el.tagName === 'INPUT' ||
        el.tagName === 'TEXTAREA' ||
        el.tagName === 'SELECT' ||
        el.isContentEditable);

    if (isTypingTarget) return;


    const key = e.key.toLowerCase();

    if (
      key === '/' &&
      !e.ctrlKey &&
      !e.metaKey &&
      !e.altKey &&
      !e.shiftKey
    ) {
      e.preventDefault();
      this.focusSearch();
    }
  }

  closeAddImanageDocPopupEvent() {
    this.modalRef.hide();
  }

  getContactCountries() {
    this.userManagementService.getContactCountries().pipe(takeUntil(this.unsubscribe)).subscribe({
      next: (result) => {
      this.contactcountries = result;
      if (this.stateManagement.getContactCountries.value == null) {
        this.stateManagement.updateData(this.stateManagement.getContactCountries, result);
      }
    },
      error: (error) => {
        this._toastr.error("Failed to load countries");
    }
  });
  };

  closeDropdown(): void {
    const dropdowns = document.querySelectorAll('.dropdown-menu.show');

    dropdowns.forEach((dropdown: Element) => {
      dropdown.classList.remove('show');
    });

    const toggles = document.querySelectorAll('.dropdown-toggle[aria-expanded="true"]');

    toggles.forEach((toggle: Element) => {
      toggle.setAttribute('aria-expanded', 'false');
    });
  }

  applyClientViewFromHeader(data: any) {
    this.stateManagement.notifyClientCreated(data);
  }

  onAddEditJobCallbackFromHeader(data: any) {
    this.stateManagement.notifyJobCreated(data);
  }

  closeQuickAddTimesheetpopupFromHeader(data: any) {
    this.modalRef.hide();
    this.stateManagement.notifyTimeLogCreated(data);
  }
}
